// extracted by mini-css-extract-plugin
export default {"root":"SelectablePeople_root__Lc-dD","normal":"SelectablePeople_normal__WOlCE","selected":"SelectablePeople_selected__Zoj5g","sides":"SelectablePeople_sides__aAeoW"};